import React from 'react';

interface ValueDisplayProps {
  label: string;
  value: string;
}

export function ValueDisplay({ label, value }: ValueDisplayProps) {
  // TODO: change className to value-display
  return (
    <div className="value-display">
      <dt className="value-display-label">{label}:</dt>
      <dd className="value-display-value">{value}</dd>
    </div>
  );
}
